var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 77,
    viewBox: "0 0 82 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1663 23.9583C8.08275 23.9583 5.58301 26.4581 5.58301 29.5416V57.4583C5.58301 60.5419 8.08275 63.0416 11.1663 63.0416H55.833C58.9166 63.0416 61.4163 60.5419 61.4163 57.4583V29.5416C61.4163 26.4581 58.9166 23.9583 55.833 23.9583H11.1663ZM10.2373 26.9083C10.5279 26.8058 10.8406 26.75 11.1663 26.75H55.833C56.1587 26.75 56.4714 26.8058 56.7621 26.9083L35.1006 42.0713C34.1394 42.7442 32.86 42.7442 31.8988 42.0713L10.2373 26.9083ZM8.41904 29.0432C8.38989 29.2049 8.37467 29.3715 8.37467 29.5416V57.4583C8.37467 59.0001 9.62455 60.25 11.1663 60.25H55.833C57.3748 60.25 58.6247 59.0001 58.6247 57.4583V29.5416C58.6247 29.3715 58.6095 29.2049 58.5803 29.0432L36.7015 44.3584C34.7791 45.7041 32.2203 45.7041 30.2978 44.3584L8.41904 29.0432Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 20.5,
    r: 20.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1304 14.0366C71.4396 14.3458 71.4396 14.847 71.1304 15.1562L60.3935 25.8931C60.0843 26.2023 59.5831 26.2023 59.2739 25.8931L53.7322 20.3514C53.423 20.0423 53.423 19.541 53.7322 19.2319C54.0414 18.9227 54.5426 18.9227 54.8518 19.2319L59.8337 24.2138L70.0109 14.0366C70.32 13.7274 70.8213 13.7274 71.1304 14.0366Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0003 33.25C70.8704 33.25 77.2503 26.8701 77.2503 19C77.2503 11.13 70.8704 4.75002 63.0003 4.75002C55.1303 4.75002 48.7503 11.13 48.7503 19C48.7503 26.8701 55.1303 33.25 63.0003 33.25ZM63.0003 34.8334C71.7448 34.8334 78.8337 27.7445 78.8337 19C78.8337 10.2555 71.7448 3.16669 63.0003 3.16669C54.2558 3.16669 47.167 10.2555 47.167 19C47.167 27.7445 54.2558 34.8334 63.0003 34.8334Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailConfirm);
export default __webpack_public_path__ + "static/media/mail_confirm.4983fc1297db7bb6058a4d6b5ca05c21.svg";
export { ForwardRef as ReactComponent };